<template lang="pug">
div
  v-menu(v-model="show" rounded="lg" allow-overflow :close-on-content-click="false" :close-on-click="!openDialog" offset-y :attach="attach !== undefined" max-height="345")
    template(#activator="{ on, attrs }")
      v-sheet.text-md.round-xl(v-bind="attrs" v-on="on" :class="error ? 'error-border-menu' : 'border-menu'" flat outlined :height="height || (showPersonInCharge !== undefined ? '60' : '48')" min-width="240")
        .d-flex.align-center.fill-height.px-4
          div.flex-grow-1(v-if="Object.keys(value).length > 0")
            .text-md.text-left(style="font-size: 15px !important;") {{ value.extra_data.sold_by }}
            .text-xs.text-left.neutral500--text(v-if="showPersonInCharge !== undefined")
              span {{ value.extra_data.name }}
              span(v-if="value.extra_data.name && value.extra_data.phone") &nbsp;(+{{ value.extra_data.phone }})
              span(v-else-if="value.extra_data.phone") +{{ value.extra_data.phone }}
          .text-sm.flex-grow-1.neutral500--text.text-left(v-else) Select {{ text || 'seller' }}
          v-icon(size="24") $yzi-chevron-down
      div.text-xs.danger500--text.ml-3.mt-1.mb-2(v-show="error") This field is required
    .text-xs.white
      .search-input
        v-text-field.mb-2.mx-4.text-sm.round-xl(v-model="itemName" outlined :placeholder="$t('search_or_add_new')" dense hide-details autofocus)
        v-divider
        template(v-if="showAddSeller !== undefined")
          div.d-flex.align-center.px-4.py-3.hover-bg(@click="createNewSeller")
            div.text-sm.flex-grow-1.font-semibold.neutral700--text.clickable.underline Create new {{ text || 'seller' }}
          v-divider
      div.d-flex.justify-center(v-if="isFetching")
        v-progress-linear(:width="3" rounded color="primary" indeterminate)
      div(v-for="item in filteredItems")
        div.px-4.py-3(v-if="isItemDisabled(item)" style="background-color: var(--v-neutral300)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.value }}
          .d-flex.align-center.text-xs.neutral500--text
            div(v-if="item.extra_data.name") {{ item.extra_data.name }}
            div.mr-1(v-if="item.extra_data.name && item.extra_data.phone") &nbsp;,&nbsp;
            div.text-xs.neutral500--text(v-if="item.extra_data.phone") +{{ item.extra_data.phone }}
        div.px-4.py-3.clickable.hover-bg(v-else @click="selectItem(item)")
          div.text-sm.flex-grow-1.neutral700--text {{ item.value }}
          .d-flex.align-center.text-xs.neutral500--text
            div(v-if="item.extra_data.name") {{ item.extra_data.name }}
            div.mr-1(v-if="item.extra_data.name && item.extra_data.phone") &nbsp;,&nbsp;
            div.text-xs.neutral500--text(v-if="item.extra_data.phone") +{{ item.extra_data.phone }}
        v-divider
      template(v-if="!filteredItems.length")
        .px-4.py-3 No results match
  .dialogs
    add-new-seller-dialog(v-if="openDialog" :open.sync="openDialog" @closed="openDialog = false" @updated="fetchMedicationSellers")
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import AddNewSellerDialog from '@/components/clinic/inventory/AddNewSellerDialog.vue'

export default {
  components: { AddNewSellerDialog },
  props: ['value', 'error', 'attach', 'showAddSeller', 'showPersonInCharge', 'text', 'height'],
  data: () => ({
    isLoading: false,
    isFetching: false,
    openDialog: false,
    show: false,
    itemName: null,
    sellers: [],
  }),
  computed: {
    ...mapGetters({ company: 'getCompany' }),
    filteredItems() {
      if (this.itemName) {
        const keyword = this.itemName.toLowerCase()
        return this.sellers.filter(item => (item.value.toLowerCase().includes(keyword)))
      }
      return this.sellers
    },
  },
  watch: {
    show (val) {
      if (val) {
        this.fetchMedicationSellers()
      } else {
        this.$emit('closed')
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchMedicationSellers () {
      this.isFetching = true
      const params = {
        enabled: true,
        company: this.company.id,
        field: 'medication.sold_by',
        page_size: -1
      }
      this.$axios.get('/options', { params })
        .then(resp => {
          if (resp.data && resp.data.results) {
            this.sellers = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetching = false
        })
    },
    createNewSeller () {
      this.openDialog = true
    },
    selectItem (item) {
      this.$emit('input', item)
      this.$emit('change')
      this.show = false
      this.itemName = ''
    },
    isItemDisabled(item) {
      return JSON.stringify(this.value) === JSON.stringify(item.extra_data)
    }
  }
}
</script>

<style scoped>
.border-menu {
  border: 1px solid var(--v-basic500);
  box-shadow: none;
}
.error-border-menu {
  border: 1px solid var(--v-danger500);
  box-shadow: none;
}
.search-input {
  position: sticky;
  top: 0px;
  background-color: #FFFFFF !important;
  border-color: #FFFFFF !important;
  z-index: 4;
  padding-top: 8px;
}
</style>